import React from "react";

/**
 * Choose how the website should render this product/service detail page.
 * - html: freeform landing Content (blog-like page builder)
 * - json: structured SectionsJson blocks
 */
export function DetailContentModePicker({ value, onChange }) {
  const mode = value === "json" ? "json" : "html";

  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-4 sm:p-5">
      <h3 className="text-sm font-semibold text-slate-900">Detail page method</h3>
      <p className="mt-1 text-xs leading-5 text-slate-500">
        Choose one method for the website detail page. The site should read{" "}
        <code className="rounded bg-slate-100 px-1">detailContentMode</code> and render either HTML
        content or JSON sections.
      </p>
      <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2">
        <button
          type="button"
          onClick={() => onChange("html")}
          className={`rounded-xl border p-4 text-left transition ${
            mode === "html"
              ? "border-brand-600 bg-brand-50 ring-2 ring-brand-600/20"
              : "border-slate-200 hover:bg-slate-50"
          }`}
        >
          <div className="text-sm font-semibold text-slate-900">HTML / Page builder</div>
          <p className="mt-1 text-xs leading-5 text-slate-500">
            Same as blogs — headings, text, images, tables, columns, and buttons in freeform content.
          </p>
        </button>
        <button
          type="button"
          onClick={() => onChange("json")}
          className={`rounded-xl border p-4 text-left transition ${
            mode === "json"
              ? "border-brand-600 bg-brand-50 ring-2 ring-brand-600/20"
              : "border-slate-200 hover:bg-slate-50"
          }`}
        >
          <div className="text-sm font-semibold text-slate-900">JSON sections</div>
          <p className="mt-1 text-xs leading-5 text-slate-500">
            Structured blocks (hero, use cases, specification tables, feature cards, infographics)
            for branded detail layouts.
          </p>
        </button>
      </div>
    </div>
  );
}
